module.exports = __webpack_public_path__ + "static/media/lr.905d5885.svg";